module.exports = __webpack_public_path__ + "static/media/privacy_policy.fc497fa8.md";